<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="visible">        
        <div class="rule-modal u-window">           
            <div class="dialog-content">              
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-rule"></div>

                    <div class="rules">
                        <div class="rule-text">
                            <p v-for="(item,index) in rule" :key="index"><em class="tag" :class="'t-' + (index + 1)" v-html="index+1"></em> <span v-html="item.text"></span></p>
                        </div>
                    </div>


                </div>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    name : 'evt_rule_modal',
    data : function () {
        return {
            visible : false,
            evt_time : '6月1日——7月3日',
            rule_text :{
                'evt' : [
                    {
                        tag : '',
                        text : '活动时间：9月1日-9月28日，共4周。',
                    },
                    {
                        tag : '',
                        text : '获取经验：参与天命*荆州争霸地图，每击败1名敌方英雄获取1点经验值。',
                    },
                    {
                        tag : '',
                        text : '每周上限：4周的经验上限分别为500/1000/1500/2000，达到上限后本周经验及总经验不再增加。',
                    },
                    {
                        tag : '',
                        text : '购买经验：不足的经验可使用非绑币购买，1梦币=1经验值，购买经验达到每周上限后，经验及总经验也不再增加。',
                    },
                    {
                        tag : '',
                        text : '领取奖励：累计经验值可解锁相应奖励，普通奖励为免费解锁，鸡王奖励需付费开启后解锁。解锁后可一键领取未领取的奖励，奖励将发送至军师邮件中。',
                    }, 
                    {
                        tag : '',
                        text : '鸡王福利：所有玩家登录绑定后每周可领一次【枪王福利宝袋】，以绑定时间算为第一周，解锁鸡王奖励后每周可领一次【枪王升级宝袋】，以解锁时间算为第一周，未领取的奖励可累积到下一周。'
                    },                                                           
                ],
                'share' : [
                    {
                        tag : '活动时间',
                        text : '2022/3/3 至 2022/3/24',
                    },
                    {
                        tag : '玩法说明',
                        text : '活动期间,分享页面,当其他仙术师通过分享链接登录界面即为助力成功。',
                    },                    
                ],
            },
            type : 'evt',          
        }
    },
    computed :{
        rule (newVal){
            return this.rule_text[this.type]
        },        
    },    
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    methods: {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
    }    
}
</script>

<style scoped>

    .rule-modal{
        width: 578px;
        height: 772px;
        font-size: 22px;
        color: #713725;
        background-image: url(~@/assets/images/bg-rule.png);
    }


    .t-rule{
        width: 195px;
        height: 28px;
        margin: 0 auto 15px;
        background-image: url(~@/assets/images/title-rule.png);
    }

    .rule-modal .dialog-wrapper{
        padding: 20px 0 0;
    }
    
    .rule-text{
        padding: 0 30px;
    }

    .rule-text p{
        position: relative;
        line-height: 1.6;
        padding-left: 50px;
        margin-bottom: 5px;
    }

    .rule-modal p .tag{
        display: block;
        position: absolute;
        left: 0;
        top: 3px;
        width: 26px;
        height: 26px;
        line-height: 26px;
        /* background-image: url(~@/assets/images/bg-index.png); */
        font-size: 0;
        color: #fff1b2;
        text-align: center;
    }
  
    .tag.t-1{
        background-image: url(~@/assets/images/tag/1.png);
    }

    .tag.t-2{
        background-image: url(~@/assets/images/tag/2.png);
    }
    
    .tag.t-3{
        background-image: url(~@/assets/images/tag/3.png);
    }
    
    .tag.t-4{
        background-image: url(~@/assets/images/tag/4.png);
    }
    
    .tag.t-5{
        background-image: url(~@/assets/images/tag/5.png);
    }
    
    .tag.t-6{
        background-image: url(~@/assets/images/tag/6.png);
    }    
</style>


// WEBPACK FOOTER //
// src/components/EvtRule/EvtRule.vue